<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyword" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" class="chaxun"
          >查询</Button
        ><Button @click="exportAll" class="chaxun">导出</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="fenpei(row, index)">分配</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button
          size="small"
          @click="del(row, index)"
          :disabled="row.useType != null"
          >删除</Button
        >
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增设备' : '编辑设备'"
      width="700"
      ref="formModel"
      :labelWidth="110"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <binecarperson ref="binecarperson" @value="bind"></binecarperson>
  </div>
</template>
<script>
import binecarperson from "./binecarperson.vue";
export default {
  components: { binecarperson },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },

        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
          sort: 7.1,
        },
      ],
      tableData: [],
      item: {
        deviceNo: "",
        id: 0,
        model: "",
        simNo: "",
        brand: "",
        expiredTime: 0,
        firmContact: "",
        firmName: "",
        mileageRatio: 0,
        monitorType: 0,
        name: "",
        protocol: "",
        purchaseTime: 0,
        purpose: "",
        remark: "",
        snNo: "",
      },
      forms: [
        {
          title: "设备号",
          minWidth: 150,
          key: "deviceNo",
          type: "Input",
          required: true,
        },
        {
          title: "sim卡号",
          key: "simNo",
          type: "Input",
          required: true,
        },
        {
          title: "设备类型",
          key: "model",
          type: "Select",
          selectItems: [],
          required: true,
        },
        {
          title: "里程系数",
          key: "mileageRatio",
          type: "Input",
        },
        {
          title: "设备协议",
          key: "protocol",
          type: "Select",
          selectItems: [],
        },
        {
          title: "品牌",
          key: "brand",
          type: "Input",
        },

        {
          title: "厂家名称",
          key: "firmName",
          type: "Input",
        },
        {
          title: "监控类型",
          key: "monitorType",
          key2: "monitorType2",
          type: "Select1",
          st: "monitorType",
        },
        

        {
          title: "采购时间",
          key: "purchaseTime",
          type: "lyyymmdd",
        },

        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/device/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].purchaseTime2 = this.utils.time(data[i].purchaseTime);
          data[i].monitorType = String(data[i].monitorType);
          data[i].monitorType2 = this.$t('monitorType.'+data[i].monitorType)
        }

        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }

      this.item = a;

      if (this.isAdd) {
        this.utils.loading(this, "提交中");
        this.axios({
          method: "post",
          url: this.axios.dm + "/device/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.utils.loading(this, "提交中");
        this.axios({
          method: "post",
          url: this.axios.dm + "/device/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/device/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    fenpei(v) {
      this.deviceNo = v.deviceNo;
      this.$refs.binecarperson.reachData(v);
    },
    bind(v) {
      console.log(v);
      this.$Modal.confirm({
        title: "是否将设备" + this.deviceNo + v.model + v.name,
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/device/bind",
            data: v,
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    chaxun(){
      this.getList();
    },
    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        b[i].sort = i + 1;
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 100;
          b[i].maxWidth = 200;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }

      //this.columns.splice(3, 0, ...b);

      this.columns = this.columns.concat(b).sort(function up(x, y) {
        return x.sort - y.sort;
      });
      console.log(this.columns);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
    //	openApi
    getDictionary() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceModel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = JSON.parse(res.data.data.value);
        for (const i in this.forms) {
          if (this.forms[i].key == "model") {
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].name);
            }
          }
        }
      });
    },
    getDictionary1() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceProtocol",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = JSON.parse(res.data.data.value);
        for (const i in this.forms) {
          if (this.forms[i].key == "protocol") {
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].name);
            }
          }
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(this.axios.dm + "/device/export", params);
    },
  },
  mounted() {
    this.cols();
    this.getDictionary();
    this.getDictionary1();
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/information/device.vue